<template>
  <!-- 我的订单 -->
  <div class="IA_My_Orders">
    <van-nav-bar :title="'我的订单'"
                 left-text
                 left-arrow
                 @click-left="onClickLeft"
                 :fixed="true" />
    <div class="content">
      <van-tabs v-model="activeName"
                @change="changeActive">
        <van-tab title="全部"
                 name="a"></van-tab>
        <van-tab title="待兑换"
                 name="b"></van-tab>
        <van-tab title="已兑换"
                 name="c"></van-tab>
        <van-tab title="已过期"
                 name="d"></van-tab>
      </van-tabs>
      <div class="goods_list"
           v-if="activeName != 'b'">
        <div class="goods_box"
             v-for="(item,idx) in orderList"
             :key="idx">
          <div class="goods_head">
            <div class="left"><van-icon name="bag-o" />商品信息</div>
            <div class="right"
                 :style="{ color: item.flag == 0 ? '#00BFFF' : item.flag == 1 ? '#228B22' : item.flag == 2 ? '#EE2C2C' : '#fd0088'}">{{item.flag == 0 ? '待兑换' : item.flag == 1 ? '已兑换' : item.flag == 2 ? '已过期' : ''}}</div>
          </div>
          <div class="goods_body">
            <div class="goods_img">
              <van-image :src="item.pt_bg_url?item.pt_bg_url:require('@assets/img/loading-error.png')"
                         :scale="1"
                         :width="'100%'"></van-image>
            </div>
            <div class="goods_desc">
              <div class="name">{{item.ptname_fullname}}</div>
              <div class="list">
                <div>数量：{{item.outnum}}</div>
                <div>所需积分：{{item.credit}}</div>
              </div>
            </div>
          </div>
          <div class="goods_footer">
            <div class="label">合计抵扣</div>
            <div class="point">{{item.total_credit}}积分</div>
          </div>
          <div class="goods_footer"
               v-if="item.flag == 0 || item.flag == 2"
               style=" margin-top: 5px;">
            <div class="label">截止兑换日期</div>
            <div class="point">{{item.outdate}}</div>
          </div>
        </div>
        <div v-if="orderList.length == 0"
             style="margin-top: 100px; font-size: 17px; text-align: center;">{{$t('module.NoData')}}</div>
      </div>
      <!-- 待兑换列表 -->
      <div class="goods_list"
           v-else>
        <div class="goods_box"
             v-for="(item,idx) in orderList"
             :key="idx">
          <div class="goods"
               v-for="(it,ix) in item.origin"
               :key="'b'+ix">
            <div class="goods_head"
                 v-if="ix == 0">
              <div class="left"><van-icon name="bag-o" />商品信息</div>
              <div class="right"
                   :style="{ color: '#00BFFF'}">待兑换</div>
            </div>
            <div class="goods_body">
              <div class="goods_img">
                <van-image :src="it.pt_bg_url?it.pt_bg_url:require('@assets/img/loading-error.png')"
                           :scale="1"
                           :width="'100%'"></van-image>
              </div>
              <div class="goods_desc">
                <div class="name">{{it.ptname_fullname}}</div>
                <div class="list">
                  <div>数量：{{it.outnum}}</div>
                  <div>所需积分：{{it.credit}}</div>
                </div>
              </div>
            </div>
            <div class="goods_footer">
              <div class="label">合计抵扣</div>
              <div class="point">{{it.total_credit}}积分</div>
            </div>
          </div>
          <div class="Redemption_code">
            <div class="out_date">截止兑换日期：{{item.outdate}}</div>
            <van-button round
                        size="small"
                        plain
                        color="#fd0088"
                        @click="getRedemptionCode(item)">兑换码</van-button>
          </div>
        </div>
        <div v-if="orderList.length == 0"
             style="margin-top: 100px; font-size: 17px; text-align: center;">{{$t('module.NoData')}}</div>
      </div>
    </div>
    <!-- 兑换码 -->
    <van-popup class="Redemption_code_pop"
               v-model="showReCode"
               closeable
               round
               close-icon="close">
      <div class="title">兑换码</div>
      <div class="qrcode">
        <qrcode :text="redemptionUrl" />
      </div>
    </van-popup>
  </div>

</template>

<script>
import qrcode from '@components/qrcode'
import { getEmpExchangeOrderRecord } from '@api/integral.js'
import { getWxUrl } from '@api/wx.js'
export default {
  components: {
    qrcode
  },
  data () {
    const userInfo = localStorage.userInfo
      ? JSON.parse(localStorage.userInfo)
      : {}
    return {
      userInfo,
      activeName: 'b',
      initOrders: [],
      orderList: [],
      showReCode: false,
      redemptionUrl: '', // 内推二维码
    }
  },
  computed: {
    flagStyle () {
      return {}
    }
  },
  created () {
    this.getEmpExchangeOrderRecordData()
  },
  methods: {
    // 生成兑换码
    getRedemptionCode (item) {
      getWxUrl().then(res => {
        if (this.$getObject(res) == 'String')
        {
          this.redemptionUrl = res + '/productExChangeCode?guid=' + item.guid
          this.showReCode = true
        }
      })
    },
    // tab切换事件：flag--0待兑换，1已兑换，2已过期
    changeActive (name, title) {
      // this.onRefreshAwait()
      console.log(name, 'changeActive', this.activeName);
      if (name == 'a')
      {
        // 全部
        this.orderList = this.initOrders
      } else if (name == 'b')
      {
        // 待兑换
        this.orderList = this.getGroupByGuid(this.initOrders.filter(it => it.flag == 0))
        console.log(this.orderList, 'this.orderList');
      } else if (name == 'c')
      {
        // 已兑换
        this.orderList = this.initOrders.filter(it => it.flag == 1)
      } else if (name == 'd')
      {
        // 已过期
        this.orderList = this.initOrders.filter(it => it.flag == 2)
      }
    },
    // 根据guid分组
    getGroupByGuid (arry) {
      let afterData = [];
      let tempArr = [];
      // 遍历分组
      for (let i = 0; i < arry.length; i++)
      {
        if (!tempArr.includes(arry[i].guid))
        {
          let arr = [];
          arr.push(JSON.parse(JSON.stringify(arry[i])));
          afterData.push({
            guid: arry[i].guid,
            outdate: arry[i].outdate,
            origin: arr,
          });
          tempArr.push(arry[i].guid);
        } else
        {
          for (let j = 0; j < afterData.length; j++)
          {
            if (afterData[j].guid == arry[i].guid)
            {
              afterData[j].origin.push(
                JSON.parse(JSON.stringify(arry[i]))
              );
              break;
            }
          }
        }
      }
      return afterData
    },
    // 获取本人所有兑换记录
    getEmpExchangeOrderRecordData () {
      getEmpExchangeOrderRecord({
        username: this.userInfo.username
      }).then(res => {
        this.initOrders = JSON.parse(JSON.stringify(res.data))
        if (this.activeName == 'b')
        {
          // 如果是待兑换则分组
          this.orderList = this.getGroupByGuid(res.data.filter(it => it.flag == 0))
        }
      })
    },
    // 返回
    onClickLeft () {
      this.$router.push({ path: '/pointsExchange', query: { from: this.$route.query.from } })
    },
  }

}
</script>

<style lang="less" scoped>
.IA_My_Orders {
  height: 100vh;
  overflow: hidden;
  .van-nav-bar {
    background: #2b8df0;
    /deep/ .van-nav-bar__left {
      .van-icon {
        color: #fff;
      }
    }
    /deep/.van-nav-bar__title {
      color: #fff;
      font-size: 36px;
      font-family: Source Han Sans CN;
    }
  }
  .content {
    // overflow: auto;
    margin-top: 1.22667rem;
    height: calc(100% - 92px);
    .van-tabs {
      height: 90px;
    }
    .goods_list {
      height: calc(100% - 90px);
      overflow-y: auto;
      .goods_box {
        padding: 20px;
        margin: 20px;
        background: #ffffff;
        border-radius: 20px;
        .goods {
          margin-bottom: 40px;
        }
        .Redemption_code {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .out_date {
            color: #646566;
            font-size: 28px;
          }
          .van-button {
            width: 25%;
            font-size: 28px;
          }
        }
        .goods_head {
          display: flex;
          justify-content: space-between;
          margin-bottom: 30px;
          .left {
            font-size: 32px;
            font-weight: bold;
          }
          .right {
            font-size: 28px;
            color: #fd0088;
          }
        }
        .goods_body {
          display: flex;
          justify-content: space-between;
          margin-bottom: 30px;
          .goods_img {
            // flex: 1;
            width: 30%;
            margin-right: 20px;
          }
          .goods_desc {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .name {
              font-size: 28px;
            }
            .list {
              display: flex;
              justify-content: space-between;
              font-size: 26px;
              color: #ee2d35;
            }
          }
        }
        .goods_footer {
          display: flex;
          justify-content: space-between;
          font-size: 28px;
          .label {
            color: #646566;
          }
          .point {
          }
        }
      }
    }
  }
  .Redemption_code_pop {
    width: 80%;
    .title {
      padding: 20px 0;
      background: linear-gradient(to bottom, #9cbce6, #deebf9);
      background-size: 100%;
      color: #367ce3;
      font-size: 50px;
      font-weight: bold;
      text-align: center;
    }
    .qrcode {
      margin: 50px 0;
    }
  }
  /deep/.van-popup__close-icon {
    color: #367ce3;
  }
}
</style>